import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 1.2rem;
  overflow: hidden;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  margin-bottom: 1.2rem;
  background-color: ${({ theme }) => theme.colors.black};
`;

export const VideoWrap = styled.div`
  position: relative;
`;

export const Video = styled.video<{ $mirrored: boolean }>`
  width: 100%;
  max-height: 40rem;
  object-fit: cover;
  display: block;
  transform: ${({ $mirrored }) => ($mirrored ? 'scaleX(-1)' : 'none')};
`;

export const Preview = styled.img`
  width: 100%;
  max-height: 40rem;
  object-fit: cover;
  display: block;
`;

export const FlipBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 1.8rem;
  border: none;
  background-color: ${({ theme }) => theme.colors.overlayDark};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const Row = styled.div`
  display: flex;
  gap: 0.8rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.darkSlate};
`;

export const PrimaryBtn = styled.button`
  flex: 1;
  padding: 1rem 1.6rem;
  border-radius: 1rem;
  border: none;
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryBtn = styled.button`
  flex: 1;
  padding: 1rem 1.6rem;
  border-radius: 1rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.slateGrey};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.borderStrong};
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
`;

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.colors.errorRed};
  font-size: 1.3rem;
  text-align: center;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.darkSlate};
`;

export const HiddenCanvas = styled.canvas`
  display: none;
`;
